import Vue from 'vue'
import Vuex from 'vuex'
//import createPersistedState from "vuex-persistedstate";

// Load Vuex
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    active: 0,
    api_status: "",
    authenticated: false,
    VueRechercheArticle: false,
    VueRechercheDesignation: false,
    VueRechercheOffre: false,
    VueRechercheProjet: false,
    VueRechercheMenu: true,
    articles: null,
    articleSelectedQuotationNumber: "",
    articleSelectedQuotationFileName: "",
    convertOk: false,
    designationSelectedArticle: "",
    designationQuotations: false,
    edi: "",
    ggmProject: null,
    ggmProjectQuotationTitle: null,
    is_loading: false,
    libelle: "",
    marque: "",
    marques: null,
    netstoreReport: null,
    projects: null,
    projectReference: null,
    quotations: null,
    quotationReference: "",
    quotationNumberToASW: "",
    searchArticlesQuotations: null,
    searchQuotations: null,
    stockDialog: false,
    stockConectis_is_loading: false,
    stockConectis: 0,
    titleChange: false,
    usersList: null,
    searchUsersList: null,
    usersListBool: [],
    usersResponse: "",
    authenticatedAdmin: false,
    axios_error: null,
    ArticleHeaders: [
      {
        text: "Marque",
        align: "left",
        value: "Brand",
      },
      { text: "Description", value: "Description" },
      { text: "Libellé", value: "LIBELLE240" },
      { text: "Prix net actuel (€)", align: "end", value: "ACT_NET_PRICE" },
      { text: "MOQ", align: "end", value: "MOQ" },
      { text: "Quantité", align: "end", value: "QT" },
      { text: "Unité", value: "UB" },
    ],
    ArticleFullHeaders: [
      {
        text: "Référence",
        align: "left",
        sortable: true,
        value: "EDI_Code",
      },
      { text: "Marque", value: "Brand" },
      { text: "Description", value: "Description" },
      { text: "Libellé", value: "LIBELLE240" },
      { text: "Prix net actuel (€)", align: "end", value: "ACT_NET_PRICE" },
      { text: "MOQ", align: "end", value: "MOQ" },
      { text: "Quantité", align: "end", value: "QT" },
      { text: "Unité", value: "UB" },
    ],
    ArticlesHeaders: [
      {
        text: "n° d'offre",
        align: "end",
        sortable: true,
        value: "QUOTATION_NUMBER",
      },
      { text: "Réf. d'offre", value: "QUOTATION_TITLE" },
      { text: "N° de ligne", align: "end", value: "LINE_NUMBER" },
      { text: "Réf. ASW", value: "ASW_REFERENCE" },
      { text: "Quantité", align: "end", value: "QUANTITY" },
      { text: "Unité de vente", value: "UNIT" },
      { text: "Prix net", align: "end", sortable: true, value: "NET_PRICE", },
      { text: "Date de l'offre", value: "QUOTATION_DATE" },
      { text: "Date de validite", value: "QUOTATION_VALIDITY_DATE" },
    ],
    ArticleQuotations: [],
    ConectisQuotation: [],
    dataArticle: [],
    dataDesignation: [],
    infoDesignation: [],
    InfoDesignationHeaders: [
      { text: "Operator", value: "OPERATOR" },
      { text: "Description", value: "DESCRIPTION" },
      { text: "Example", value: "EXAMPLE" },
    ],
    ProjectsHeaders: [
      {
        text: "n° d'offre",
        align: "end",
        sortable: false,
        value: "QUOTATION_NUMBER",
      },
      { text: "N° de ligne", align: "end", value: "LINE_NUMBER" },
      { text: "Réf. ASW", value: "ASW_REFERENCE" },
      { text: "Quantité", align: "end", value: "QUANTITY" },
      { text: "Unité de vente", value: "UNIT" },
      { text: "Prix net", align: "end", sortable: true, value: "NET_PRICE", },
      { text: "Date de l'offre", value: "QUOTATION_DATE" },
      { text: "Date de validite", value: "QUOTATION_VALIDITY_DATE" },
    ],
    QuotationsHeaders: [
      { text: "N° de ligne", align: "end", value: "LINE_NUMBER" },
      { text: "Réf. ASW", value: "ASW_REFERENCE" },
      { text: "Quantité", align: "end", value: "QUANTITY" },
      { text: "Unité de vente", value: "UNIT" },
      { text: "Prix net", align: "end", sortable: true, value: "NET_PRICE", },
      { text: "Date de l'offre", value: "QUOTATION_DATE" },
      { text: "Date de validite", value: "QUOTATION_VALIDITY_DATE" },
    ],
    UsersHeaders: [
      {
          text: "Nom",
          align: "left",
          value: "NOM",
      },
      { text: "Prenom", value: "PRENOM" },
      { text: "email", value: "EMAIL" },
      { text: "Admin", align: "end", value: "ADMIN" },
      { text: 'Actions', value: 'actions', sortable: false },
    ],
    selected: [],
    StockConectisHeaders: [
      { text: "Stock", value: "QUANTITE" },
    ]
},
  mutations: {
    
  },
  actions: {

  },
  //plugins: [createPersistedState()]
})

